module.exports = __webpack_public_path__ + "baa72870d73744ebc1541ae8da10814d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-stores/app-store.svg
// module id = 2174
// module chunks = 0 1 2